import { updateLiquidityOneOffCashflowPanelSettings } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySettingsMutation } from './use-liquidity-settings-mutation';

export const useUpdateLiquidityOneOffCashflowPanelSettings = () =>
    useLiquiditySettingsMutation({
        mutationFn: (payload) => updateLiquidityOneOffCashflowPanelSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityOneOffCashflowSettings,
        scope: 'panel',
    });
